import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HideImageIcon(props: IconProps) {
    return <Icon {...props} iconKey={"hide_image"}/>
}
